import { AxiosResponse } from "../interface";
import { axiosInstanceWebsite } from "../instance";
import { Product } from "../../components/products/ProductInterface";

export interface ProductsPageResponse {
  items: Product[];
  page: number;
  size: number;
  total_items: number;
  total_pages: number;
}

interface GetProductsParams {
  page?: number;
  size?: number;
  search?: string;
}

export const getProductsPage = async (params?: GetProductsParams): Promise<ProductsPageResponse> => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/store/product`,
    { params }
  );

  if (Array.isArray(response.data)) {
    const items = response.data.reverse();
    return {
      items,
      page: params?.page ?? 0,
      size: params?.size ?? items.length,
      total_items: items.length,
      total_pages: items.length > 0 ? 1 : 0,
    };
  }

  return {
    items: response.data?.items || [],
    page: response.data?.page ?? params?.page ?? 0,
    size: response.data?.size ?? params?.size ?? 15,
    total_items: response.data?.total_items ?? 0,
    total_pages: response.data?.total_pages ?? 0,
  };
};

export const getProducts = async () => {
  const response = await getProductsPage();
  return response.items;
};

export const putProduct = async (data: Product) => {
    const response: AxiosResponse = await axiosInstanceWebsite.put(
      `/store/product/${data.id}`,
      data
    );
    return response.data;
};

export const cloneProduct = async (productId: string) => {
  const response = await axiosInstanceWebsite.post(
    `/store/product/${productId}/clone`
  );
  return response.data;
};
